import { useCoverage } from './CoverageContext';
import { SourceIdentifier } from '@ais-ui/api-spec/coverage';
import { CoverageImageWMSLayer } from './CoverageImageLayer';
import { useMemo } from 'react';

interface SingleCoverageLayerProps {
  sourceIdentifier: SourceIdentifier;
}

const SingleCoverageLayer = ({
  sourceIdentifier,
}: SingleCoverageLayerProps) => {
  const { coverageOverlays } = useCoverage();

  const properties = useMemo(() => {
    return {
      id: sourceIdentifier.id,
      name: `coverage ${
        sourceIdentifier.pssMmsi !== -1
          ? sourceIdentifier.pssMmsi
          : sourceIdentifier.sourceTag
      }`,
      pssMmsi: sourceIdentifier.pssMmsi,
      sourceTag: sourceIdentifier.sourceTag,
      extent: coverageOverlays[sourceIdentifier.id]?.imageExtent,
    };
  }, [coverageOverlays, sourceIdentifier]);

  if (!coverageOverlays[sourceIdentifier.id]) {
    return null;
  }

  return (
    <CoverageImageWMSLayer
      key={sourceIdentifier.id}
      overlay={coverageOverlays[sourceIdentifier.id].base64}
      extent={coverageOverlays[sourceIdentifier.id].imageExtent}
      name={properties.name}
      properties={properties}
    />
  );
};

export function CoverageLayer() {
  const { selectedSourceIdentifiers, coverageOverlays } = useCoverage();

  return (
    <>
      {selectedSourceIdentifiers.map((sourceIdentifier) => (
        <SingleCoverageLayer
          key={sourceIdentifier.id}
          sourceIdentifier={sourceIdentifier}
        />
      ))}
    </>
  );
}
